export enum CustomFieldType {
    FreeText = 0,
    SingleSelect = 1,
    MultipleSelect = 2,
    Boolean = 3,
    SingleSelectUser = 4,
    MultiSelectUser = 5,
    FileUpload = 6,
    TextBlock = 7,
    SignDocument = 8
}

export enum TypeOfTimeSlot {
    Undefined = 0,
    DateAndTime = 1,
}

export enum TimeSlotIcsSetting {
    Undefined = 0,
    IgnoreTimeSlots = 1,
    ReplaceByTimeSlot = 2,
    AddTimeSlots = 3,
}
export class MultipleChoiceConfigOptions {
    constructor(public typeOfTimeSlot: TypeOfTimeSlot = TypeOfTimeSlot.Undefined, public timeSlotIcsSetting: TimeSlotIcsSetting = TimeSlotIcsSetting.Undefined,
        public minSelect: number = 1, public maxSelect: number = null) {
    }
}

export enum StandardFieldType {
    Undefined = 0,
    Name = 1,
    Email = 2,
    Mobile = 3,
    Company = 4,
    JobTitle = 5,
    Address = 6,
    CustomerNumber = 7
}

export enum RegistrationPageType {
    Undefined = 0,
    Dashboard = 1,
    LandingPage = 2,
    PublicLandingPage = 3,
    Frontdesk = 4
}

export enum StandardFieldTypeLabel {
    Email = 1,
    MobilePhone = 2,
    CompanyName = 3,
    Address = 4,
    JobTitle = 5,
    CustomerNumber = 6
}
